import { postTaskComment, clickupAPI } from "../../../../utils/api/clickup";
import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Cookies from 'js-cookie';

// Rate limiting constants
const RATE_LIMIT = 100;
const INTERVAL = 60000 / RATE_LIMIT;
let lastRequestTime = 0;
// not sure if this is used
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const CommentDetails = ({ taskComments, taskID }) => {
  const [comments, setComments] = useState(taskComments || { comments: [] });
  const [comment, setComment] = useState("");

  const handleInputChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = async () => {
    if (comment.trim()) {
      const now = Date.now();
      const timeSinceLastRequest = now - lastRequestTime;

      if (timeSinceLastRequest < INTERVAL) {
        await delay(INTERVAL - timeSinceLastRequest);
      }

      try {
        const user = Cookies.get('cp-un')
        const formattedComment = `${user}\n${comment}`
        const response = await clickupAPI({action: 'postComment', taskId: taskID, comment: formattedComment});

        if (response) {
          await fetchComments();
        }

        setComment("");
        lastRequestTime = Date.now();
      } catch (error) {
        console.error("Failed to post comment:", error);
      }
    }
  };

  const fetchComments = async () => {
    try {
      const response = await clickupAPI({action: 'getTaskComments', taskId:taskID });
      setComments(response || { comments: [] }); 
    } catch (error) {
      console.error("Failed to fetch comments:", error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [taskID]);

  if (
      !comments ||
      !comments.comments ||
      comments.comments.length === 0
    ) {
    return (
      <div>
        <p>No Comments to Display</p>
        <div className="commentSubmitBtn">
          <TextField
            id="outlined-multiline-flexible"
            label="Add a Comment..."
            multiline
            onChange={handleInputChange}
            maxRows={4}
            fullWidth
            value={comment}
          />
          <Button variant="contained" onClick={handleSubmit}>Send</Button>
        </div>
      </div>
    );
  }

  const formatDate = (timestamp) => {
    const date = new Date(parseInt(timestamp));
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="commentsContainer">
      <div className="commentsList">
        {comments.comments
          .slice()
          .reverse()
          .map((commentGroup, groupIndex) => (
            <div key={groupIndex} className="commentBoxes">
              <div className="commentHeader">
                <strong>{commentGroup.user.username}</strong>
                <strong>{formatDate(commentGroup.date)}</strong>
              </div>
              {commentGroup.comment
                .filter((commentObj) => commentObj.text.trim() !== "")
                .map((commentObj, index) => (
                  <div key={index}>
                    {commentObj.text.split("\n").map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                ))}
            </div>
          ))}
      </div>
      {/* when they click send, we grab the value that is in TextField and send that to clickup */}
      <div className="commentSubmitBtn">
        <TextField
          id="outlined-multiline-flexible"
          label="Write a comment..."
          multiline
          maxRows={4}
          fullWidth
          onChange={handleInputChange}
          value={comment}
        />
        <Button variant="contained" onClick={handleSubmit}>
          Send
        </Button>
      </div>
    </div>
  );
};

export default CommentDetails;
